import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ORDER_ITEM_LOADING = 'GET_ORDER_ITEM_LOADING';
export const GET_ORDER_ITEM_SUCCESS = 'GET_ORDER_ITEM_SUCCESS';
export const GET_ORDER_ITEM_REJECT = 'GET_ORDER_ITEM_REJECT';

//* ACTIONS ------------------------------------------------
export const getOrderItemLoading = () => ({ type: GET_ORDER_ITEM_LOADING });
export const getOrderItemSuccess = (payload) => ({ type: GET_ORDER_ITEM_SUCCESS, payload });
export const getOrderItemReject = (payload) => ({ type: GET_ORDER_ITEM_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getOrderItemRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Items/GetOrderItems`, options);
};
